var _rect, _path, _path2, _path3, _g, _g2, _g3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlexibleModels(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 474,
    height: 290,
    viewBox: "0 0 474 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 471,
    height: 287,
    rx: 8.5,
    stroke: "#203155",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.9597 105.512V104.008H67.8797V115H69.5117V110.216H75.3357V108.712H69.5117V105.512H75.9597ZM86.4587 107.592C86.4587 105.496 84.6987 104.008 82.3787 104.008H77.7547V115H79.3707V111.176H81.8987L84.5867 115H86.4427L83.6427 111.016C85.3067 110.584 86.4587 109.288 86.4587 107.592ZM79.3707 105.512H82.1547C83.7387 105.512 84.8107 106.296 84.8107 107.592C84.8107 108.888 83.7387 109.672 82.1547 109.672H79.3707V105.512ZM96.3816 105.512V104.008H88.3016V115H96.3816V113.496H89.9336V110.152H95.7576V108.648H89.9336V105.512H96.3816ZM106.491 105.512V104.008H98.4109V115H106.491V113.496H100.043V110.152H105.867V108.648H100.043V105.512H106.491Z",
    fill: "#00B0A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M210.004 109.496C210.004 106.408 207.412 103.816 204.324 103.816C201.236 103.816 198.612 106.408 198.612 109.496C198.612 112.584 201.236 115.192 204.324 115.192C205.636 115.192 206.868 114.712 207.844 113.928L209.076 115L210.004 113.912L208.836 112.904C209.572 111.944 210.004 110.76 210.004 109.496ZM204.324 113.704C202.132 113.704 200.276 111.784 200.276 109.496C200.276 107.224 202.132 105.304 204.324 105.304C206.516 105.304 208.356 107.224 208.356 109.496C208.356 110.36 208.084 111.176 207.636 111.864L206.02 110.456L205.092 111.544L206.66 112.904C206.004 113.4 205.188 113.704 204.324 113.704ZM216.781 115.192C219.533 115.192 221.501 113.192 221.501 110.376V104.008H219.869V110.344C219.869 112.312 218.589 113.72 216.781 113.72C214.957 113.72 213.677 112.312 213.677 110.344V104.008H212.061V110.376C212.061 113.192 214.013 115.192 216.781 115.192ZM232.622 115H234.414L229.694 104.008H227.902L223.182 115H224.974L225.934 112.76H231.662L232.622 115ZM226.558 111.304L228.798 106.088L231.038 111.304H226.558ZM244.732 107.592C244.732 105.496 242.972 104.008 240.652 104.008H236.028V115H237.644V111.176H240.172L242.86 115H244.716L241.916 111.016C243.58 110.584 244.732 109.288 244.732 107.592ZM237.644 105.512H240.428C242.012 105.512 243.084 106.296 243.084 107.592C243.084 108.888 242.012 109.672 240.428 109.672H237.644V105.512ZM249.631 115H251.247V105.512H254.863V104.008H246.031V105.512H249.631V115ZM264.78 105.512V104.008H256.7V115H264.78V113.496H258.332V110.152H264.156V108.648H258.332V105.512H264.78ZM275.513 107.592C275.513 105.496 273.753 104.008 271.433 104.008H266.809V115H268.425V111.176H270.953L273.641 115H275.497L272.697 111.016C274.361 110.584 275.513 109.288 275.513 107.592ZM268.425 105.512H271.209C272.793 105.512 273.865 106.296 273.865 107.592C273.865 108.888 272.793 109.672 271.209 109.672H268.425V105.512Z",
    fill: "#192643"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M361.95 115H363.742L359.022 104.008H357.23L352.51 115H354.302L355.262 112.76H360.99L361.95 115ZM355.886 111.304L358.126 106.088L360.366 111.304H355.886ZM365.548 115H367.164V106.664L373.484 115H375.1V104.008H373.484V112.344L367.164 104.008H365.548V115ZM377.892 115H379.508V106.664L385.828 115H387.444V104.008H385.828V112.344L379.508 104.008H377.892V115ZM394.844 115.192C397.596 115.192 399.564 113.192 399.564 110.376V104.008H397.932V110.344C397.932 112.312 396.652 113.72 394.844 113.72C393.02 113.72 391.74 112.312 391.74 110.344V104.008H390.124V110.376C390.124 113.192 392.076 115.192 394.844 115.192ZM410.684 115H412.476L407.756 104.008H405.964L401.244 115H403.036L403.996 112.76H409.724L410.684 115ZM404.62 111.304L406.86 106.088L409.1 111.304H404.62ZM415.579 113.496V104.008H413.947V115H421.403V113.496H415.579Z",
    fill: "#192643"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8368_730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 146C17 143.791 18.7909 142 21 142H153C155.209 142 157 143.791 157 146V269C157 271.209 155.209 273 153 273H21C18.7909 273 17 271.209 17 269V146Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8368_730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167 146C167 143.791 168.791 142 171 142H303C305.209 142 307 143.791 307 146V269C307 271.209 305.209 273 303 273H171C168.791 273 167 271.209 167 269V146Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_8368_730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317 146C317 143.791 318.791 142 321 142H453C455.209 142 457 143.791 457 146V269C457 271.209 455.209 273 453 273H321C318.791 273 317 271.209 317 269V146Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 154,
    width: 114,
    height: 8,
    rx: 3,
    fill: "#D6DEF1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 170,
    width: 114,
    height: 8,
    rx: 3,
    fill: "#D6DEF1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 186,
    width: 61,
    height: 8,
    rx: 3,
    fill: "#D6DEF1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 154,
    width: 114,
    height: 8,
    rx: 3,
    fill: "#D6DEF1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 170,
    width: 114,
    height: 8,
    rx: 3,
    fill: "#D6DEF1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 186,
    width: 61,
    height: 8,
    rx: 3,
    fill: "#D6DEF1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 211,
    width: 114,
    height: 8,
    rx: 3,
    fill: "#D6DEF1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 227,
    width: 61,
    height: 8,
    rx: 3,
    fill: "#D6DEF1"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 154,
    width: 114,
    height: 8,
    rx: 3,
    fill: "#D6DEF1"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 170,
    width: 114,
    height: 8,
    rx: 3,
    fill: "#D6DEF1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 186,
    width: 61,
    height: 8,
    rx: 3,
    fill: "#D6DEF1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 211,
    width: 114,
    height: 8,
    rx: 3,
    fill: "#D6DEF1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 227,
    width: 114,
    height: 8,
    rx: 3,
    fill: "#D6DEF1"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 243,
    width: 61,
    height: 8,
    rx: 3,
    fill: "#D6DEF1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8368_730",
    x: 13,
    y: 138,
    width: 148,
    height: 139,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8368_730"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8368_730",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8368_730",
    x: 163,
    y: 138,
    width: 148,
    height: 139,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8368_730"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8368_730",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_8368_730",
    x: 313,
    y: 138,
    width: 148,
    height: 139,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8368_730"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8368_730",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexibleModels);
export default __webpack_public_path__ + "static/media/flexible_models.cc712bb733e4e97036c21594d9b64b36.svg";
export { ForwardRef as ReactComponent };